import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { SIZES } from '../../constants/constants';
import { useI18n } from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';

export const DEFAULT_EDITABLE_PANEL_COLLAPSE_ACTION_TEST_ID_PREFIX = 'collapse-action';

export interface CollapseActionIconButtonProps {
    contentCollapsed: boolean;
    panelContentId: string;
    onClick: () => void;
    dataTestId: string;
}

export const CollapseActionIconButton = ({
    contentCollapsed,
    panelContentId,
    onClick,
    dataTestId
}: CollapseActionIconButtonProps) => {
    const t = useI18n();
    const tooltipLabelExpand = t('dialog.expand');
    const tooltipLabelCollapse = t('dialog.collapse');
    const buttonLabelExpand = t('common.expand.panel');
    const buttonLabelCollapse = t('common.collapse.panel');
    return (
        <Tooltip title={contentCollapsed ? tooltipLabelExpand : tooltipLabelCollapse}>
            <IconButton
                data-testid={`${DEFAULT_EDITABLE_PANEL_COLLAPSE_ACTION_TEST_ID_PREFIX}-${dataTestId}`}
                size={SIZES.small}
                onClick={onClick}
                aria-expanded={!contentCollapsed}
                aria-controls={panelContentId}
                aria-label={contentCollapsed ? buttonLabelExpand : buttonLabelCollapse}
            >
                {contentCollapsed ? <Icons.UnfoldMore /> : <Icons.UnfoldLess />}
            </IconButton>
        </Tooltip>
    );
};
